module.exports = __webpack_public_path__ + "static/media/application_expired.8763e008.svg";